import React, { useState } from 'react';
import ManageBatch from '../components/Programs/ManageBatch';
import Aside from '../modules/SideNav/Aside';

function ManageBatchLayout() {
    const rtl = false;

    const [toggled, setToggled] = useState(false);

    const handleToggleSidebar = value => {
        setToggled(value);
    };

    return (
        <div className={`app ${rtl ? 'rtl' : ''} ${toggled ? 'toggled' : ''}`}>
            <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            />
            <ManageBatch handleToggleSidebar={handleToggleSidebar} />
        </div>
    );
}

export default ManageBatchLayout;
